import badIcon from '../../assets/icons/Feedback/bad-emoji.svg';
import okIcon from '../../assets/icons/Feedback/ok-emoji.svg';
import goodIcon from '../../assets/icons/Feedback/good-emoji.svg';
import { IFeedbackRatingItem, IFeedbackRatingPills } from '../types/Feedback';

const OkBadRatingPills = [
  { id: '9', name: 'UNCLEAR_DESCRIPTIONS' },
  { id: '11', name: 'MMISSING_KEY_DATA' },
  { id: '12', name: 'POOR_DATA_VISUALISATION' },
  { id: '13', name: 'TOO_MUCH_INFO' },
  { id: '14', name: 'NOT_EASY_TO_USE' },
  { id: '15', name: 'LOADING_SPEED' },
];

export const FeedbackRating: IFeedbackRatingItem[] = [
  { key: 'bad', name: 'BAD', icon: badIcon },
  { key: 'ok', name: 'OK', icon: okIcon },
  { key: 'good', name: 'GOOD', icon: goodIcon },
];

export const FeedbackRatingPills: IFeedbackRatingPills = {
  good: [
    { id: '1', name: 'CLEAR_DESCRIPTIONS' },
    { id: '2', name: 'SUFFICIENT_DATA' },
    { id: '3', name: 'HELPFUL_DATA' },
    { id: '4', name: 'GOOD_DATA_VISUALISATION' },
    { id: '5', name: 'RELEVANT_INFO' },
    { id: '6', name: 'EASY_TO_USE' },
    { id: '7', name: 'LOADING_SPEED' },
  ],
  ok: OkBadRatingPills,
  bad: OkBadRatingPills,
};
